/**
 * SGKC008A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface TankatableMeisaiDto {

    /**
     * 更新通番号
     */
    updateSrno?: string;
    /**
     * プロダクトコード
     */
    prdCode?: string;
    /**
     * 商品コード
     */
    goodsCode?: string;
    /**
     * 料金計算定義料金コード
     */
    chargeCode?: string;
    /**
     * 単価指定区分１コード
     */
    tankaSiteiDiv1?: string;
    /**
     * 単価指定区分２コード
     */
    tankaSiteiDiv2?: string;
    /**
     * 単価指定区分３
     */
    tankaSiteiDiv3?: string;
    /**
     * 単価指定区分４
     */
    tankaSiteiDiv4?: string;
    /**
     * 単価指定区分５
     */
    tankaSiteiDiv5?: string;
    /**
     * 単価範囲開始値
     */
    tankaRangeStart?: number;
    /**
     * 適用開始日付
     */
    applyStartDate?: string;
    /**
     * 適用終了日付
     */
    applyEndDate?: string;
    /**
     * 単価正式名称
     */
    tankaAname?: string;
    /**
     * 単価略称名称
     */
    tankaRyaku?: string;
    /**
     * 単価範囲終了値
     */
    unitPriceRangeEnd?: number;
    /**
     * 単価
     */
    tanka?: number;
    /**
     * 調整単価コード
     */
    choseiTankaCode?: string;
    /**
     * 単位
     */
    unit?: string;
    /**
     * 超過単価
     */
    exceedUnitPrice?: number;
    /**
     * 超過単位
     */
    exceedUnit?: string;
}

